var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c(_vm.template, {
    tag: "component"
  }, [_c('div', [_c('v-card', {
    staticClass: "overflow-visible",
    attrs: {
      "tile": "",
      "elevation": "0"
    }
  }, [_c('div', [_c('div', {
    staticClass: "tit-wrap tit-wrap--unberline"
  }, [_c('h2', {
    staticClass: "tit"
  }, [_vm._v("도서 구매내역")])]), _c('mypage-dashboard-head', {
    staticClass: "mb-2 mb-md-12",
    class: {
      'mt-n7': _vm.detect == 'mobile'
    }
  }), _c('div', {
    staticClass: "mb-4"
  }, [_c('shop-purchase-list-filter')], 1), _c('div', {
    staticClass: "mb-30px mb-md-40px"
  }, [_c('shop-purchase-tabs')], 1)], 1), _c('v-tabs-items', {
    attrs: {
      "touchless": ""
    },
    model: {
      value: _vm.tab,
      callback: function callback($$v) {
        _vm.tab = $$v;
      },
      expression: "tab"
    }
  }, [_c('v-tab-item', {
    attrs: {
      "value": "ebook"
    }
  }, [_c('shop-purchase-ebuk', {
    attrs: {
      "isOn": _vm.tab == 'ebook'
    }
  })], 1), _c('v-tab-item', {
    attrs: {
      "value": "book"
    }
  }, [_c('shop-purchase-book', {
    attrs: {
      "isOn": _vm.tab == 'book'
    }
  })], 1), _c('v-tab-item', {
    attrs: {
      "value": "gift"
    }
  }, [_c('shop-purchase-gift', {
    attrs: {
      "isOn": _vm.tab == 'gift'
    }
  })], 1)], 1)], 1)], 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }